import HorizontalImageCard from "../elements/horizontalImageCard";


export default function CarouselCard11() {

    return (
        <div className="flex">

            <div className="">
                <div className="grid grid-cols-1 md:grid-cols-2 md:w-full mx-12">
                    <div className="swiper-slide card-slide card-slide-left  ">

                        <HorizontalImageCard
                            imageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/editorial/img-fe2e3cfd.webp"
                            imageAlt="Extern Academy Academics"
                            title="Individualized Pathways"
                            blurb="There’s no
                                    one-size-fits-all
                                    approach. Our
                                    students have
                                    the opportunity
                                    to dive deep
                                    into advanced
                                    subjects or
                                    explore new
                                    interests.
                                    Either way, they
                                    have the freedom
                                    to pave their
                                    own path."
                        />
                    </div>
                    <div className="swiper-slide card-slide card-slide-center  ">

                        <HorizontalImageCard
                            imageURL="https://firebasestorage.googleapis.com/v0/b/extern-academy.firebasestorage.app/o/website%2Fimages%2FDSC08508.JPG.webp?alt=media&token=ae0376a0-13a6-4195-a317-08f16f44b96d"
                            imageAlt="Startup Counseling"
                            title="Startup Counseling"
                            blurb="Our Startup
                                Trainers don’t
                                just coach you
                                through the
                                program — they
                                help you think
                                through your
                                next move. Whether
                                that’s college,
                                a gap year, or
                                launching
                                something of your
                                own, you’ll leave
                                with a clear
                                direction and the
                                confidence to
                                pursue it."
                        />
                    </div>


                </div>

            </div>
        </div>
    )
}